import { useState, useCallback } from 'react';
import { TimeLogApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { ProjectWithClientInfo } from '../../../commonTypes/acs';

const useHttpGetSubmissionIntervalsByYear = () => {
    const timeLogApi: TimeLogApi = useContainer(TimeLogApi);
    const [submittedSet, setSubmittedSet] = useState<Set<string>>(new Set());
    const [isLoading, setIsLoading] = useState(false);

    const fetch = useCallback((userSub: string, projects: ProjectWithClientInfo[], year: number) => {
        if (!userSub || !projects.length) return;

        const projectUserPairs = projects.map(p => ({ projectId: p.id, userSub }));
        const from = `${year}-01-01`;
        const to = `${year}-12-31`;

        setIsLoading(true);

        const { exec, abort } = timeLogApi.getSubmissionIntervalsByProjectsAndAssignees({
            params: { from, to },
            body: { projectUserPairs },
            onSuccess: res => {
                const set = new Set<string>();
                res.body.forEach(interval => {
                    const month = new Date(interval.startDate).getUTCMonth() + 1;
                    set.add(`${interval.projectId}:${month}`);
                });
                setSubmittedSet(set);
                setIsLoading(false);
            },
            onError: () => setIsLoading(false),
        });

        exec();
        return abort;
    }, []);

    return { submittedSet, isLoading, fetch };
};

export default useHttpGetSubmissionIntervalsByYear;
